import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './components/app/app.component';
import { AppRoutingModule } from './app-routing.module';
import { MDBSpinningPreloader, MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { MdbCalendarModule } from 'mdb-calendar';
import { MdbColorPickerModule } from 'mdb-color-picker';
import { MdbDraggableModule } from 'mdb-draggable';
import { MdbFileUploadModule } from 'mdb-file-upload';
import { MdbSortableModule } from 'mdb-sortable';
import { MdbTableEditorModule } from 'mdb-table-editor';
import { MdbWysiwygModule } from 'mdb-wysiwyg';
import { HomePageComponent } from './pages/home/home-page.component';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { PropertyPageComponent } from './pages/property-page/property-page.component';
import { PropertyYearPageComponent } from './pages/property-year-page/property-year-page.component';
import { FormInputComponent } from './forms/form-input/form-input.component';
import { FormOkCancelComponent } from './forms/form-ok-cancel/form-ok-cancel.component';
import { FormButtonComponent } from './forms/form-button/form-button.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PageLoaderComponent } from './components/page-loader/page-loader.component';
import { FormSelectComponent } from './forms/form-select/form-select.component';
import { FormCheckboxComponent } from './forms/form-checkbox/form-checkbox.component';
import { BadgeComponent } from './components/badge/badge.component';
import { FormFileEntryListComponent } from './forms/form-file-entry-list/form-file-entry-list.component';
import { FormFileEntryComponent } from './forms/form-file-entry/form-file-entry.component';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AuthComponent } from './components/auth/auth.component';
import { AuthGuard } from './services/auth.guard';
import { FormHelpComponent } from './forms/form-help/form-help.component';
import { FormFileImageComponent } from './forms/form-file-image/form-file-image.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,

    PropertyPageComponent, PropertyYearPageComponent,

    FormInputComponent, FormOkCancelComponent, FormButtonComponent, FormSelectComponent, FormCheckboxComponent,
    FormFileEntryListComponent, FormFileEntryComponent, FormHelpComponent,
    
    PageHeaderComponent, PageLoaderComponent,
    CardHeaderComponent,
    BadgeComponent,
    AuthComponent,
    FormFileImageComponent
  ],
  imports: [
    AppRoutingModule,

    BrowserModule, BrowserAnimationsModule,

    FormsModule,
    HttpClientModule,
    ToastModule.forRoot(),
    
    MDBBootstrapModulesPro.forRoot(),
    MdbCalendarModule, MdbColorPickerModule, MdbDraggableModule, MdbFileUploadModule, MdbSortableModule, MdbTableEditorModule, MdbWysiwygModule,

    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule, 

  ],
  providers: [
    AuthGuard,
    MDBSpinningPreloader
  ],
  bootstrap: [AppComponent],
  schemas:      [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }